import { api } from './api';
import { User, UserUpdate } from '../types/user';

export const userService = {
    async getCurrentUser(): Promise<User> {
        const response = await api.get('/users/me');
        return response.data;
    },

    async getUserById(userId: number): Promise<User> {
        const response = await api.get(`/users/${userId}`);
        return response.data;
    },

    async getUsers(): Promise<User[]> {
        const response = await api.get('/users');
        return response.data;
    },

    async updateUser(userData: UserUpdate): Promise<User> {
        const response = await api.put(`/users/${userData.id}`, {
            email: userData.email,
            first_name: userData.first_name,
            last_name: userData.last_name,
            role: userData.role
        });
        return response.data;
    }
}; 